import { gql } from '@apollo/client'

export const GET_TOP_EMPTY_FACINGS_SNAPSHOTS = gql`
  query GetTopEmptyFacingsSnapshots(
    $filters: DashboardFilter!
    $pagination: OffsetLimitPaginationFilter
  ) {
    topEmptyFacingsSnapshots(filters: $filters, pagination: $pagination) {
      totalCount
      results {
        id
        created
        captureTime
        type
        display {
          id
          name
        }
        images {
          id
          url
        }
      }
    }
  }
`
